<app-citizen-header></app-citizen-header>
<div class="bg-white">
  <div class="p-5 move-left">
    <div class="mt-3 flex justify-center items-start">
      <div class="w-2/3">
        <div class="flex mb-2 items-center">
          <div class="mr-2 cursor-pointer flex items-center">
            <button class="button mr-2" routerLink="/home">
              <div class="button-box">
                <span class="button-elem">
                  <svg viewBox="0 0 46 40" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z"
                    ></path>
                  </svg>
                </span>
                <span class="button-elem">
                  <svg viewBox="0 0 46 40" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z"
                    ></path>
                  </svg>
                </span>
              </div>
            </button>
          </div>
          <span class="heading text-primary-500"
            >Frequently Asked Questions (FAQs)</span
          >
        </div>

        <p class="text-[16px]">
          Find the answer to some of our most frequently asked questions
        </p>
        <app-shared-accordion
          *ngFor="let question of frequentlyAskedQuestionsList$ | async"
          [header]="question.questionName"
          [content]="question.questionAnswer"
        >
        </app-shared-accordion>

        <p class="text-[16px]">
          If you have any inquiries or feedbacks, please
          <a href="/contact" class="text-primary-500" style="font-weight: bold"
            >contact us</a
          >
        </p>
      </div>
    </div>
  </div>
  <app-portal-footer></app-portal-footer>
</div>
